import React from 'react';
import CommonHeader from './CommonHeader';
import styles from './Marketplace.module.scss';

const Marketplace: React.FC = () => {
  return (
    <div className={styles.marketplaceContainer}>
      <CommonHeader />
      
      <main className={styles.marketplaceMain}>
        <div className={styles.marketplaceContent}>
          <h1 className={styles.marketplaceTitle}>Marketplace</h1>
          <p className={styles.marketplaceDescription}>
            Coming Soon - Explore products and services from other sellers
          </p>
        </div>
      </main>
    </div>
  );
};

export default Marketplace;